export default function Modal({ open, onClose, eyebrow, title, children, maxWidth = 'max-w-3xl' }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-[#0f172a]/45 px-4 py-6 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className={`flex max-h-[92vh] w-full ${maxWidth} flex-col overflow-hidden rounded-[28px] border border-surface-container-highest bg-surface shadow-[0_24px_80px_rgba(15,23,42,0.28)]`}
        onClick={(e) => e.stopPropagation()}
      >
        {(eyebrow || title) && (
          <div className="flex shrink-0 items-start justify-between gap-4 border-b border-surface-container-high px-6 py-5">
            <div>
              {eyebrow && (
                <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-on-surface-variant">{eyebrow}</div>
              )}
              {title && <h2 className="studio-uniform-title mt-2 text-on-surface">{title}</h2>}
            </div>
            <button
              type="button"
              onClick={onClose}
              className="rounded-2xl border border-surface-container-high px-4 py-2 text-[10px] font-medium text-on-surface"
            >
              Fechar
            </button>
          </div>
        )}
        <div className="studio-modal-scroll min-h-0 flex-1 overflow-y-auto px-6 py-6">{children}</div>
      </div>
    </div>
  );
}